import {Alert, Button, Card, Col, Container, Dropdown, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import React, {FC, useEffect, useState} from "react";
import axios from "axios";
import {useAuth} from "../../../context/AuthProvider";
import paginationFactory, {} from "react-bootstrap-table2-paginator";
import {useTranslation} from "react-i18next";
import moment from "moment";
import filterFactory, {Comparator, selectFilter, textFilter} from "react-bootstrap-table2-filter";

import BootstrapTable, {SizePerPageRendererOptions} from "react-bootstrap-table-next"
import {Link} from "react-router-dom"

type UserManagementComponentProps = Record<string, unknown>

const UserManagementComponent: FC<UserManagementComponentProps> = () => {
    const auth = useAuth()
    const {t, i18n} = useTranslation("admin")

    const [users, setUsers] = useState<any[]>([])
    const [toContact, setToContact] = useState<any[]>([]);

    useEffect(() => {
        axios.get("/api/user/list", auth.axiosAuthHeader()).then(res => {
            setUsers(res.data)
        })
    }, [])
    const caretDefinition = (order: any) => {
        if (!order) {
            return <><i className="bi bi-arrow-down-up ms-1"/> </>
        }

        return order === 'asc'
            ? <><i className="bi bi-sort-up ms-1"/> </>
            : <><i className="bi bi-sort-down ms-1"/> </>
    }

    const impersonate = (_id: any) => {
        axios.get("/api/user/impersonate/" + _id, auth.axiosAuthHeader()).then(res => {
            console.log(res.data)
            auth.impersonate(res.data.jwt)
        })
    };
    const featureKeys = (row: any): string[] => {
        const features: string[] = []
        if (row.title) features.push("title")
        if (row.eduPersonScopedAffiliation?.some((a: string) => a.startsWith("employee@"))) {
            features.push("employee")
        }
        if (row.eduPersonScopedAffiliation?.some((a: string) => a.startsWith("faculty@"))) {
            features.push("faculty")
        }
        if (row.tenants?.some((tenant: any) => tenant.isDean === true)) {
            features.push("dean")
        }
        if (row.tenants?.some((tenant: any) => tenant.isInfrastructure === true)) {
            features.push("infrastructure")
        }
        if (row.isAdmin === true) features.push("admin")
        if (row.isExamOfficeEmployee === true) features.push("examOfficeEmployee")
        if (row.isExamOfficeAssistant === true) features.push("examOfficeAssistant")
        return features
    }

    const roleLabels: Record<string, string> = {
        facultyOwner: t("users.roles.facultyOwner"),
        deputy: t("users.roles.deputy"),
        disabilityOfficer: t("users.roles.disabilityOfficer"),
        reader: t("users.roles.reader"),
    }
    const columns = [{
        dataField: '_id',
        text: '#',
        formatter: (cell: any, row: any, rowIndex: number) => {
            return rowIndex + 1;
        },
        sort: false,
        filter: false
    },
        //     {
        //     dataField: '_id',
        //     text: "ID",
        //     sort: true,
        //     filter: textFilter({
        //         placeholder: ' '
        //     }),
        //     formatter: (cell: any) => {
        //         return cell.replace("urn:schac:personalUniqueCode:int:esi:tu-darmstadt.de:", "")
        //     },
        //     sortCaret: caretDefinition
        // },
        {
            dataField: 'preferred_username',
            text: "TU-ID",
            sort: true,
            filter: textFilter({
                placeholder: ' '
            }),
            sortCaret: caretDefinition
        }, {
            dataField: 'given_name',
            text: t("users.columns.givenName"),
            sort: true,
            filter: textFilter({
                placeholder: ' '
            }),
            sortCaret: caretDefinition
        }, {
            dataField: 'family_name',
            text: t("users.columns.familyName"),
            sort: true,
            filter: textFilter({
                placeholder: ' '
            }),
            sortCaret: caretDefinition
        }, {
            dataField: 'esi',
            text: "ESI",
            sort: true,
            filter: textFilter({
                placeholder: ' '
            }),
            formatter: (cell: any) => {
                return cell ? cell.replace("urn:schac:personalUniqueCode:int:esi:tu-darmstadt.de:", "") : null
            },
            sortCaret: caretDefinition
        }, {
            dataField: "lastLoginAt",
            text: t("users.columns.lastLogin"),
            sort: true,
            sortCaret: caretDefinition,
            filter: textFilter({
                placeholder: ' '
            }),
            formatter: (cell: any) => {
                return moment(cell).format("dd, DD.MM.YYYY HH:mm")
            },
            filterValue: (cell: any) => {
                return moment(cell).format("dd, DD.MM.YYYY HH:mm")
            },
        }, {
            dataField: "createdAt",
            text: t("users.columns.createdAt"),
            sort: true,
            sortCaret: caretDefinition,
            filter: textFilter({
                placeholder: ' '
            }),
            formatter: (cell: any) => {
                return moment(cell).format("dd, DD.MM.YYYY HH:mm")
            },
            filterValue: (cell: any) => {
                return moment(cell).format("dd, DD.MM.YYYY HH:mm")
            },
        }, {
            dataField: "tenantAssignments",
            text: t("users.columns.tenantAssignments"),
            filter: textFilter({placeholder: " "}),
            formatter: (assignments: any[] | undefined) => {
                if (!assignments?.length) return <span className="text-muted">–</span>
                return <div className="d-flex flex-column gap-1">
                    {assignments.map(assignment => <div key={assignment.tenant._id}>
                        <Link
                            to={`/tenants?tenant=${encodeURIComponent(assignment.tenant._id)}`}
                            className="text-decoration-none"
                            title={t("users.openTenantManagement")}
                            onClick={event => event.stopPropagation()}
                        >
                            <strong>{assignment.tenant.describer}</strong>{" "}
                            <span>{(i18n.language === "en" ? assignment.tenant.name?.en ?? assignment.tenant.fullName?.en : assignment.tenant.name?.de ?? assignment.tenant.fullName?.de)}</span>{" "}
                            <i className="bi bi-box-arrow-up-right small"/>
                        </Link>{" "}
                        <span className={`badge ${assignment.role ? "text-bg-primary" : "text-bg-secondary"}`}>
                            {assignment.role ? roleLabels[assignment.role] ?? assignment.role : t("users.assigned")}
                        </span>
                        {assignment.isDisabilityOfficer && assignment.role !== "disabilityOfficer" && <>
                            {" "}<span className="badge text-bg-info">{roleLabels.disabilityOfficer}</span>
                        </>}
                    </div>)}
                </div>
            },
            filterValue: (assignments: any[] | undefined) => (assignments ?? [])
                .map(assignment => [
                    assignment.tenant.describer,
                    assignment.tenant.name?.de,
                    assignment.tenant.fullName?.de,
                    assignment.role,
                    assignment.role ? roleLabels[assignment.role] : t("users.assigned"),
                    assignment.isDisabilityOfficer ? roleLabels.disabilityOfficer : null,
                ].filter(Boolean).join(" "))
                .join(" "),
            sort: true,
            sortValue: (assignments: any[] | undefined) =>
                (assignments ?? []).map(assignment => assignment.tenant.describer).join(", "),
            sortCaret: caretDefinition,
        }, {
            dataField: 'id',
            text: t("users.columns.features"),
            filter: selectFilter({
                options: {
                    title: t("users.features.title"),
                    employee: t("users.features.employee"),
                    faculty: t("users.features.faculty"),
                    dean: t("users.features.dean"),
                    infrastructure: t("users.features.infrastructure"),
                    admin: t("users.features.admin"),
                    examOfficeEmployee: t("users.features.examOfficeEmployee"),
                    examOfficeAssistant: t("users.features.examOfficeAssistant"),
                },
                comparator: Comparator.LIKE,
                placeholder: t("users.features.placeholder"),
            }),
            filterValue: (_cell: any, row: any) => featureKeys(row).join(" "),
            formatter: (cell: any, row: any) => {
                return <>
                    {(() => {
                        if (row.title) {
                            return <OverlayTrigger
                                placement="left"
                                overlay={
                                    <Tooltip id={row._id + "title"}>
                                        {row.title}
                                    </Tooltip>
                                }
                            ><i className="bi bi-award"></i></OverlayTrigger>
                        }
                        return null
                    })()}
                    {(() => {
                        if (row.eduPersonScopedAffiliation?.some((a: any) => a.startsWith("employee@"))) {
                            return <OverlayTrigger
                                placement="left"
                                overlay={
                                    <Tooltip id={row._id + "employee"}>
                                        {t("users.features.employee")}
                                    </Tooltip>
                                }
                            ><i className="bi bi-person-vcard-fill"></i></OverlayTrigger>
                        }
                        return null
                    })()}
                    {(() => {
                        if (row.eduPersonScopedAffiliation?.some((a: any) => a.startsWith("faculty@"))) {
                            return <OverlayTrigger
                                placement="left"
                                overlay={
                                    <Tooltip id={row._id + "faculty"}>
                                        {t("users.features.faculty")}
                                    </Tooltip>
                                }
                            ><i className="bi bi-mortarboard-fill text-danger"></i></OverlayTrigger>
                        }
                        return null
                    })()}
                    {featureKeys(row)
                        .filter(feature => [
                            "dean",
                            "infrastructure",
                            "admin",
                            "examOfficeEmployee",
                            "examOfficeAssistant",
                        ].includes(feature))
                        .map(feature => {
                            const icons: Record<string, string> = {
                                dean: "bi-building-fill text-primary",
                                infrastructure: "bi-tools text-secondary",
                                admin: "bi-shield-lock-fill text-danger",
                                examOfficeEmployee: "bi-person-workspace text-success",
                                examOfficeAssistant: "bi-person-check-fill text-info",
                            }

                            return <OverlayTrigger
                                key={feature}
                                placement="left"
                                overlay={
                                    <Tooltip id={`${row._id}-${feature}`}>
                                        {t(`users.features.${feature}`)}
                                    </Tooltip>
                                }
                            >
                                <i className={`bi ${icons[feature]} ms-1`}/>
                            </OverlayTrigger>
                        })}
                </>
            }
        },{
        dataField: 'ou',
        text: "OU",
        filter: textFilter({
            placeholder: ' '
        }),
    formatter: (cell: any) => {
            return cell  ? cell.join(", ") : null
        },
        sortCaret: caretDefinition
    }, {
        dataField: "actions",
        text: t("users.columns.actions"),
        filter: false,
        sort: false,
        formatter: (_cell: unknown, row: any) => (
            <div className="d-flex gap-1">
                <OverlayTrigger
                    placement="left"
                    overlay={<Tooltip id={`impersonate-${row._id}`}>{t("users.impersonateHint")}</Tooltip>}
                >
                    <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={event => {
                            event.stopPropagation()
                            impersonate(row._id)
                        }}
                    >
                        <i className="bi bi-person-bounding-box"/>
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger
                    placement="left"
                    overlay={<Tooltip id={`copy-id-${row._id}`}>{t("users.copyIdHint")}</Tooltip>}
                >
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={event => {
                            event.stopPropagation()
                            void navigator.clipboard.writeText(String(row._id))
                        }}
                    >
                        <i className="bi bi-clipboard"/>
                    </Button>
                </OverlayTrigger>
            </div>
        ),
    },
    ]
    const handleSelectedRows = () => {
        if (!toContact.length) {
            return
        }

        const params = toContact.length > 1
            ? new URLSearchParams({
                bcc: toContact.map(ct => ct.booking.user.email).join(","),
                subject: "👋",
                body: "",
            })
            : new URLSearchParams({
                to: toContact[0].booking.user.email,
                subject: "👋",
                body: "",
            })

        window.location.href = `mailto:?${params.toString()}`
    }
    const sizePerPageRenderer = ({
                                     options,
                                     currSizePerPage,
                                     onSizePerPageChange,
                                 }: SizePerPageRendererOptions) => (
        <Dropdown>
            <Dropdown.Toggle variant="secondary">
                {currSizePerPage}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {options.map(option => (
                    <Dropdown.Item
                        key={option.page}
                        onClick={() => onSizePerPageChange(Number(option.page))}
                    >
                        {option.text}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
    return (<div className="component">
        <Container fluid>
            <Row>
                <Col>
                    <Card>
                        <Card.Header><h3><i className="bi bi-people"></i> {t("users.title")}</h3></Card.Header>
                        <Card.Body>
                            {users ? <BootstrapTable keyField='_id' data={users}
                                                     columns={columns} filter={filterFactory()}
                                                     striped
                                                     hover
                                                     condensed
                                                     pagination={paginationFactory({
                                                         page: 1,
                                                         sizePerPage: 50,
                                                         sizePerPageList: [
                                                             {text: '50', value: 50},
                                                             {text: '100', value: 100},
                                                             {text: '250', value: 250},
                                                             {text: '500', value: 500}
                                                         ],
                                                         paginationSize: 15,
                                                         showTotal: true,
                                                         alwaysShowAllBtns: true,
                                                         firstPageText: '<<',
                                                         prePageText: '<',
                                                         nextPageText: '>',
                                                         lastPageText: '>>',
                                                         sizePerPageRenderer
                                                     })}
                                // defaultSorted={[
                                //     {
                                //         dataField: 'booking.user.esi',
                                //         order: 'asc'
                                //     }
                                // ]}
                                                     selectRow={{
                                                         mode: 'checkbox',
                                                         classes: 'justify-ccontent-center',
                                                         onSelect: (row, isSelect) => {
                                                             setToContact((prev: any) =>
                                                                 isSelect
                                                                     ? [...prev, row]
                                                                     : prev.filter((r: any) => r.id !== row.id)
                                                             )
                                                         },

                                                         onSelectAll: (isSelect, rows) => {
                                                             setToContact(isSelect ? rows : [])
                                                         },
                                                         selectionRenderer: ({checked}) => (
                                                             <div
                                                                 className="d-flex justify-content-center align-items-center">
                                                                 <input
                                                                     type="checkbox"
                                                                     checked={checked}
                                                                     readOnly
                                                                 />
                                                             </div>
                                                         ),
                                                         // selectionHeaderRenderer: ({
                                                         //                               checked,
                                                         //                               indeterminate
                                                         //                           }) => (
                                                         //     <div
                                                         //         className="d-flex flex-wrap align-items-center justify-content-center gap-1">
                                                         //         <OverlayTrigger
                                                         //             placement="right"
                                                         //             overlay={
                                                         //                 <Tooltip id="mail-tooltip">
                                                         //                     Ausgewählte Kontakte
                                                         //                     anschreiben
                                                         //                 </Tooltip>
                                                         //             }
                                                         //         ><Button
                                                         //             size="sm"
                                                         //             onClick={(e) => {
                                                         //                 e.stopPropagation()
                                                         //                 handleSelectedRows()
                                                         //             }}
                                                         //         >
                                                         //             <i className="bi bi-envelope-at"></i>
                                                         //         </Button></OverlayTrigger>
                                                         //         <input
                                                         //             type="checkbox"
                                                         //             checked={checked}
                                                         //             ref={input => {
                                                         //                 if (input) input.indeterminate = indeterminate
                                                         //             }}
                                                         //             readOnly
                                                         //         />
                                                         //
                                                         //     </div>
                                                         // )
                                                     }}
                                                     noDataIndication={() => (
                                                         <div>
                                                             <Alert className="text-center"
                                                                    variant="info"><h3><i
                                                                 className="bi bi-search"></i> Keine
                                                                 Treffer</h3></Alert>
                                                         </div>
                                                     )}
                            /> : null}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    </div>)
}

export default UserManagementComponent
